import {
  Box,
  Button,
  Chip,
  Fab,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material"
import { useState } from "react"
import Modal from "../ui/Modal"
import { useSnackbar } from "notistack"
import DoneIcon from "@mui/icons-material/Done"
import CloseIcon from "@mui/icons-material/Close"

const TakeAttendance = (props) => {
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)
  const mark = () => {
    props.close()
  }
  return (
    <Modal
      {...props}
      title="Take attendance for class"
      actionText="Done"
      loading={loading}
      action={mark}
      cancelText="Close"
    >
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Roll no.</TableCell>
              <TableCell>Name</TableCell>
              <TableCell align="right">Attendance</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array(10)
              .fill(0)
              .map(() => (
                <StudentAttendance />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Chip
        sx={{
          position: "sticky",
          bottom: 0,
          background: "silver",
        }}
        color="default"
        label={
          <>
            Attendance: <b>12/20</b>
          </>
        }
      />
    </Modal>
  )
}

const StudentAttendance = () => {
  const [present, setPresent] = useState(null)
  return (
    <TableRow>
      <TableCell>1</TableCell>
      <TableCell>Rakesh Das</TableCell>
      <TableCell align="right">
        <Fab
          size="small"
          onClick={() => setPresent(true)}
          color={present === true ? "success" : "default"}
        >
          <DoneIcon />
        </Fab>
        <Fab
          size="small"
          onClick={() => setPresent(false)}
          color={present === false ? "error" : "default"}
          sx={{ ml: 2 }}
        >
          <CloseIcon />
        </Fab>
      </TableCell>
    </TableRow>
  )
}

export default TakeAttendance
